<template>
  <div>
    <v-dialog
      v-model="warnDialog"
      width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline red"
          primary-title
        >
          <v-layout row justify-center>
            <v-icon dark x-large>warning</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h3>{{ warnMsg }}</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="closeWarnDialog"
          >
            {{ $translate("OK") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "WarnDialog",
  props: {
    warnMsg: String
  },
  data() {
    return {
      warnDialog: true
    };
  },
  methods: {
    closeWarnDialog() {
      this.warnDialog = false;
      this.$emit("warn-dialog-closed");
    }
  }
}
</script>